import findBet from "../find-bet";
import LeaderboardDistanceStats from "../containers/leaderboard-distance-stats";
import LeaderboardPicksRace from "./leaderboard-picks-race";
import pure from "./higher-order/pure";
import React from "react";

export default pure(({ bets, raceEntrants, races, ticket, ticketScores, tournament }) => {
  return (
    <div className="leaderboard_picks">
      <LeaderboardDistanceStats ticket={ticket} tournament={tournament} />

      <ul className="leaderboard_picks_table leaderboard_picks_table--header">
        <li className="leaderboard_picks_cell leaderboard_picks_cell--race">
          Race
        </li>

        <li className="leaderboard_picks_cell leaderboard_picks_cell--track">
          Track
        </li>

        <li className="leaderboard_picks_cell leaderboard_picks_cell--pick">
          Pick
        </li>

        <li className="leaderboard_picks_cell leaderboard_picks_cell--horse" />

        <li className="leaderboard_picks_cell leaderboard_picks_cell--odds">
          ML
        </li>

        <li className="leaderboard_picks_cell leaderboard_picks_cell--results">
          Fin
        </li>

        <li className="leaderboard_picks_cell leaderboard_picks_cell--rank">
          Rank
        </li>

        <li className="leaderboard_picks_cell leaderboard_picks_cell--score">
          Score
        </li>
      </ul>

      {races.map((race, i) => {
        var bet = findBet(bets, race.get("id"), ticket.get("id"));
        var ticketScore = findBet(ticketScores, race.get("id"), ticket.get("id"));

        var entrant;
        if (bet) {
          entrant = raceEntrants.get(bet.get("race_entrant_id"));
        }
        return (<LeaderboardPicksRace bet={bet} key={race.get("id")} number={i + 1} race={race} raceEntrant={entrant} ticket={ticket} ticketScore={ticketScore} tournament={tournament} />);
      })}
    </div>
  );
});
